__turbopack_context__.v({
  "burger": "style-module-scss-module__-g9rAW__burger",
  "burgerMenuToggleButton": "style-module-scss-module__-g9rAW__burgerMenuToggleButton",
});
